import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation,useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { Helmet } from "react-helmet-async";

const FormBiodataPd = () => {
  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
const navigate = useNavigate();
  
  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun

  const [kelas, setKelas] = useState([]);
  const [searchParams] = useSearchParams();
    const namad = searchParams.get("nama");
 const agamaIndonesia = [
  'Islam',
  'Kristen',
  'Katolik',
  'Hindu',
  'Buddha',
  'Khonghucu',
];

  const [formdata, setFormData] = useState({
    nama:namad,
    jk:'',
   agama:'',
    nis:'', 
    nisn:'', 
    rombel_id:''
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
        setError('Data tidak boleh kosong');
        return;
    }
    console.log(formdata)

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/registrasiweb/register_datadiri_pd`, {
            method: 'POST',
           headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
            body: JSON.stringify(formdata),
        });
 const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message);
        }
  localStorage.setItem('token', result.token);
       
  window.location.href ="/login";
    } catch (error) {
        setError(`Terjadi kesalahan: ${error.message}`);
    }
};

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

   useEffect(() => {
      const getInformasiAkun = async () => {
       try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/getkelas`, {
            method: 'POST',
             headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
            body: JSON.stringify(formdata),
        });
 const result = await response.json();
 console.log(result.data)
        if (!response.ok) {
            throw new Error(result.message);
        }
setKelas(result.data)
    } catch (error) {
        setError(`Terjadi kesalahan: ${error.message}`);
    }
      };
      getInformasiAkun();
    }, []);


  return (
    <div>
      <Helmet>
              <title>Identifikasi Pengguna</title>
            </Helmet>
       <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
           <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary mt-3"><b>Hi, Selamat Datang</b></h4>
            <p className="text-muted">Lengkapi Biodata</p>
          </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      name='nama'
                      required
                      value={formdata.nama}
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="NAMA" 
                    />
                    <label htmlFor="floatingNama">Nama Asli</label>
                  </div>
                   <div className="form-floating mb-3">
                  <select
                className="form-control"
                name="jk"
                value={formdata.jk}
                onChange={(e)=> {
                    console.log(e.target.value)
                    setFormData({
                    ...formdata,
                    jk: e.target.value
                    })}
                }
                >
                <option value="">-- Pilih --</option>

                {[{value:'L',label:"Laki -Laki"},{value:'P',label:"Perempuan"}].map((item, index) => (
                    <option key={index} value={item.value}>
                    {item.label}
                    </option>
                ))}
                </select>
                 <label htmlFor="floatingNama">Jenis Kelamin</label>
                </div>
                
                    <div className="form-floating mb-3">
                    <select
                className="form-control"
                name="agama"
                value={formdata.agama}
                onChange={(e)=> {
                    console.log(e.target.value)
                    setFormData({
                    ...formdata,
                    agama: e.target.value
                    })}
                }
                >
                <option value="">-- Pilih --</option>

                {agamaIndonesia.map((item, index) => (
                    <option key={index} value={item}>
                    {item}
                    </option>
                ))}
                </select>
                    <label htmlFor="floatingNama">Agama</label>
                  </div>
                    <div className="form-floating mb-3">
                  <select
                className="form-control"
                name="kelas"
                value={formdata.rombel_id}
                onChange={(e)=> {
                    console.log(e.target.value)
                    setFormData({
                    ...formdata,
                    rombel_id: e.target.value
                    })}
                }
                >
                <option value="">-- Pilih --</option>

                {kelas.map((item, index) => (
                    <option key={index} value={item.rombel_id}>
                    {item.nama_rombel}
                    </option>
                ))}
                </select>
                    <label htmlFor="floatingNama">Kelas</label>
                  </div>

                  {/* <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={formdata.noi}
                      name='noi'
                     
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="No Induk Pegawai" 
                    />
                    <label htmlFor="floatingNama">No Induk Pegawai (Jika tidak ada Koosngkan Saja)</label>
                  </div>
                   */}
                 
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Lanjutkan</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

                <hr />
              </div>
            </div>
          </div>
  );
};

export default FormBiodataPd;
